export default "__VITE_ASSET__BMPAWJwo__"